export default __webpack_public_path__ + "static/media/adobeaudition.afa937d5.svg";